// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"AB yc","wrapperNeon":"AC yp","ribbon":"AD ym","title":"AE ye","seasons":"AF yk","genres":"AG yl","buttonWrapper":"AH yh","button":"AI yi","buttonNeon":"AJ yq"};